import  React from 'react';
import logo from '../../../images/skills/react.png';

const ReactSkill =  () => {
  return (
    <div className={'skill'}>
      <img src={logo}/>
      <h2>React</h2>
    </div>
  )
}
export default ReactSkill